export const styles = {
  button: {
    whiteSpace: 'nowrap',
  },
};
